<template>
  <v-autocomplete
    ref="autocomplete"
    :no-data-text="nodataText"
    :dense="dense"
    :value="value"
    :rules="rules"
    :items="address"
    :loading="isLoading"
    :search-input.sync="search"
    :filter="filter"
    :error-messages="errorMessages"
    clearable
    hide-selected
    :item-text="itemText"
    label="Адрес"
    outlined
    single-line
    return-object
    prepend-inner-icon="mdi-magnify"
    @click:clear="clearSearchResult"
    @input="selectedItem = $event"
  >
  </v-autocomplete>
</template>

<script>
import debounce from "lodash/debounce";
import { meetingSearchAddress } from "@/api/bids";

export default {
  name: "BidSearchAddress",
  props: {
    value: {
      type: Object,
      default: null,
    },
    filter: {
      type: Function,
      default: null
    },

    rules: Array,
    dense: Boolean,
    errorMessages: Array | String
  },

  data: () => ({
    search: null,
    address: [],
    selectedItem: null,
  }),

  computed: {
    isLoading() {
      return !!this.$store.state.common.loading;
    },
    nodataText() {
      return this.search && this.search.length >= 3 ? "Нет результатов" : "Введите минимум 3 символа для поиска";
    },
  },

  watch: {
    search(current) {
      if (!current || current.length < 3 || (!!this.value && this.itemText(this.value) === current)) return;
      this.debouncedSearch(this.search);
    },
  },

  created() {
    this.debouncedSearch = debounce(this.searchAddress, 500);
  },

  mounted() {
    if (this.value) {
      this.address = [this.value];
    }
  },

  methods: {
    itemText(item) {
      return item.value;
    },

    async searchAddress(query) {
      const res = await meetingSearchAddress({ q: query });
      if (res) {
        this.address = res;

        this.$emit('input', this.selectedItem);
      }
    },

    clearSearchResult() {
      this.address = [];
      this.$emit('clear-address', true);
    },
  },
};
</script>

<style lang="scss" scoped>
.nodata {
  padding: 16px;
}
</style>
